/**import React section */
import React from 'react'
/**import Material section */
import { Box, Button, DialogContent, Typography } from '@material-ui/core'
/**import Components section */
import DialogView from '../../common/Dialog'
import AlertComponent from '../../common/AlertComponent'
/**import Helpers section */
import { convertUrlImg } from '../ImageHelpper'
/**import Styles section */
import { ImageStyles } from './ImageStyles'

const ConfirmDeleteDialog = (props) => {
	/** Bool type props */
	const { open, isDeletingImage } = props
	/** function type props */
	const { onClose, onHandleConfirm } = props
	/** string type props */
	const { url } = props

	const classes = ImageStyles()

	return (
		<DialogView
			open={open}
			onClose={onClose}
			isSaving={isDeletingImage}
			header={<strong>CONFIRM DELETE IMAGE</strong>}
			actions={
				<>
					<Button variant='contained' className={classes.btnSaved} onClick={onHandleConfirm} disabled={isDeletingImage}>
						CONFIRM
					</Button>
				</>
			}
		>
			<DialogContent>
				{<AlertComponent title={'Warning'} message={'You are attempting to delete the image'} severityType={'warning'} />}
				<br />

				<Typography variant='subtitle2'>¿Are you sure you want to delete the image?</Typography>
				<br />

				<Box component={'img'} src={convertUrlImg(url)} alt={'attachment'} className={classes.imageDelete} />
			</DialogContent>
		</DialogView>
	)
}

export default ConfirmDeleteDialog
